import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function GitHub(props: Object) {
  return (
    <SvgIcon {...props}>
		<path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v4h10V4H7m0 6v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2m-8 4v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2m-8 4v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2z" fill="#fff"/>
    </SvgIcon>
  );
}

export default GitHub;


// WEBPACK FOOTER //
// ./src/Svg.js